// ** React Imports
import { useEffect, useState } from 'react'

// ** Axios Import
import axios from 'axios'

// ** Type Import
// import { VerticalNavItemsType } from 'src/@core/layouts/types'
import apiUrl from '../../src/configs/constant'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

const ServerSideNavItems = (enabled = true) => {
    const { user, logoutUser } = useAuth();
    const token = user?.token

    const cabang = JSON.parse(localStorage.getItem('cabang')!)
    const navigate = useNavigate();
    // ** State
    const [menuItems, setMenuItems] = useState<any>([])
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')

    useEffect(() => {
        let active = true
        setMenuItems([])
        setError('')
        setLoading(false)
        if (!enabled || !token || !cabang) return
        setLoading(true)
        let url = apiUrl.apiUrl + '/system/menu/menu-user/' + cabang

        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (!active) return
                const menu = response.data.data
                if (!Array.isArray(menu)) throw new Error('Invalid menu response')
                setMenuItems(menu)
            })
            .catch(error => {
                if (!active) return
                setError('Gagal memuat menu. Tutup lalu buka kembali pencarian.')
                if (error.response?.status === 401) {
                    logoutUser()
                    navigate("/login");
                }
            })
            .finally(() => { if (active) setLoading(false) })
        return () => { active = false }
    }, [enabled, token, cabang])

    return { menuItems, loading, error }
}

export default ServerSideNavItems
